<template>
  <div class="banner" ref="banner">
    <img :src="banner.img" alt="">
    <div class="content wow fadeInUp">
      <div class="title">{{banner.title}}</div>
      <div class="btn" @click="goto">Discover</div>
    </div>
  </div>
</template>

<script>
import Scrollbar from 'smooth-scrollbar';
export default {
  props: {
    banner:Object
  },
  mounted(){
    
  },
  methods: {
    goto(){
      let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
      let height=this.$refs.banner.clientHeight
			scrollbar.scrollTo(0,height,1000)
    }
  }
}
</script>

<style scoped>
.banner{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.banner img{
  display: block;
  width: 100%;
}
.banner .content{
  position: absolute;
  bottom: 17.9%;
  color: #fff;
  text-align: center;
}
.banner .content .title{
  font-size: 45px;
}
.banner .content .btn{
  margin-top: 60px;
  width: 200px;
  font-size: 20px;
  line-height: 45px;
  font-family: 'Embassy BT';
  border: 1px solid #fff;
  cursor: pointer;
}
@media(max-width: 768px){
  .banner{
    height: 100vh;
  }
  .banner img{
    height: 100%;
    object-fit: cover;
  }
  .banner .content{
    bottom: auto;
    top: 50%;
  }
  .banner .content .title{
    font-size: 20px;
  }
  .banner .content .btn{
    margin-top: 20px;
    width: 150px;
    line-height: 30px;
  }
}
</style>
